import { Skeleton } from '@/design-system/components/ui';

import { FixedAmount } from '../../../common/components/cards/PayoutTermCard/FormattedAmount/FormattedAmount';
import { useCurrencyBySymbol } from '../../currencies/hooks/useCurrencyBySymbol';

interface ActivityAmountCellProps {
  amount: string | null;
  paymentCurrency: string | null;
  chainIdentifier?: string | undefined | null;
}

export const ActivityAmountCell = ({ amount, paymentCurrency, chainIdentifier }: ActivityAmountCellProps) => {
  const isPointsPayout = paymentCurrency?.toLowerCase() === 'points' || paymentCurrency?.toLowerCase() === 'point';
  const { data: currencyData, isLoading: isCurrencyLoading } = useCurrencyBySymbol(
    paymentCurrency,
    chainIdentifier,
    !isPointsPayout && !!paymentCurrency,
  );

  if (!amount || amount === '0') {
    return <span>-</span>;
  }

  if (isCurrencyLoading) {
    return <Skeleton width={80} height={16} />;
  }

  return (
    <FixedAmount
      isPointsPayout={isPointsPayout}
      amount={amount}
      payoutCurrencyAddress={currencyData?.address ?? ''}
      payoutCurrencyDecimals={currencyData?.decimals ?? 18}
      payoutCurrencySymbol={paymentCurrency ?? ''}
      payoutCurrencyLogoUri={currencyData?.logoUri}
      amountFormat="decimal"
    />
  );
};
